<template>
  <v-container id="inventory-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
              id ? $i18n.t("Edit Handover ") : $i18n.t("Create Handover")
              }}
            </div>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Reg No")}}:</span>
                      <span>
                        <b>{{handover.vehicle.regNo}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Vehicle Owner")}}:</span>
                      <span>
                        <b>{{handover.vehicle.owner}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("KMs Done")}}:</span>
                      <span>
                        <b>{{handover.vehicle.kms}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Fuel Type")}}:</span>
                      <span>
                        <b>{{handover.vehicle.fuelType}}</b>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-row v-if="handover.from_driver">
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Handover From Driver")}}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      v-if="handover.from_driver && handover.from_driver.onDuty"
                    >
                      <span class="mr-4">{{$i18n.t("ON DUTY")}}:</span>
                      <span v-if="handover.from_driver.onDutySince">
                        <b>{{$i18n.t("SINCE ")}} {{handover.from_driver.onDutySince | moment("DD MMM YYYY hh:mm a")}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Name")}}:</span>
                      <span>
                        <b>{{handover.from_driver.name}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Phone")}}:</span>
                      <span>
                        <b>{{handover.from_driver.countryCode}} {{handover.from_driver.phone}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Email")}}:</span>
                      <span>
                        <b>{{handover.from_driver.email}}</b>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" v-if="handover.toDriver">
                  <v-row>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Handover To Driver")}}</span>
                    </v-col>
                    <v-col cols="12" md="12" v-if="handover.to_driver && handover.to_driver.onDuty">
                      <span class="mr-4">{{$i18n.t("ON DUTY")}}:</span>
                      <span v-if="handover.to_driver.onDutySince">
                        <b>{{$i18n.t("SINCE ")}} {{handover.to_driver.onDutySince | moment("DD MMM YYYY hh:mm a")}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Name")}}:</span>
                      <span>
                        <b>{{handover.to_driver.name}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Phone")}}:</span>
                      <span>
                        <b>{{handover.to_driver.countryCode}} {{handover.to_driver.phone}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Email")}}:</span>
                      <span>
                        <b>{{handover.to_driver.email}}</b>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" v-if="!handover.toDriver">
                  <v-row>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Handover To Supervisor")}}</span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Name")}}:</span>
                      <span>
                        <b>{{handover.to_supervisor.name}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Phone")}}:</span>
                      <span>
                        <b>{{handover.to_supervisor.countryCode}} {{handover.to_supervisor.phone}}</b>
                      </span>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="mr-4">{{$i18n.t("Email")}}:</span>
                      <span>
                        <b>{{handover.to_supervisor.email}}</b>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>-->
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  handover = { vehicle: {}, from_driver: {}, to_driver: {}, to_supervisor: {} };
  id = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/handover/save", this.handover);
      if (!this.id) this.$router.push("/handover/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/handover/vehicle/" + id + "/detail");
      this.handover = response;
      this.id = this.handover._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
